<template>

    <v-row style="overflow-y:auto; max-width: 600px; margin: 0 auto; height: 60px; scrollbar-width: none;" class="px-0 mx-auto pl-0" >
      <v-col id="foot" class="my-0 py-0" >
        <v-row class="py-0 my-0">
          <v-col v-if="$store.state.validationDelivery==false" cols="8" :style="{ 'background-color': $store.state.colors.primary }">
              <!-- <v-icon>mdi-magnify</v-icon> -->
              <v-text-field class="input-footer RestoRegular" outlined dense prepend-inner-icon="mdi-magnify" v-model="filterTask" background-color="white" placeholder=" Buscar" hide-details="true"></v-text-field>
              <!-- <input type="text" class="input-footer RestoRegular" v-model="filterTask" placeholder="Buscar" style="width:270px"> -->
          </v-col>
          <v-col v-if="$store.state.validationDelivery==false" cols="4" :style="{ 'background-color': $store.state.colors.secondary }" class="pa-0">
              <v-btn @click="$router.push({ name: 'order'})" tile text color="#ffffff" class="ma-0 pa-0 pb-1" style="width: 100%; height: 100%; text-transform: none !important; " >
                <img class='icon d-none d-sm-flex' src="@/assets/resources/icons/icon_ticket.png" style="width:30px; height:30px;"><span class="RestoRegular d-none d-sm-flex">Mi pedido</span>
                <img class='icon d-sm-none' src="@/assets/resources/icons/icon_ticket.png" style="width:22px; height:22px;"><span class="RestoRegular d-sm-none" style="font-size: 13px">Mi pedido</span>
              </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  
</template>

<script>
export default {
    data () {
        return{
          filterTask: ""
        };
    },
    watch: {
      filterTask: function(val) {
          //do something when the data changes.
          this.$store.state.footer_search=val;
      }
    }
}

</script>

<style scoped>
::-webkit-input-placeholder { /* Edge */
  color: #e6e6e6;
}

:-ms-input-placeholder { /* Internet Explorer */
  color: #e6e6e6;
}

::placeholder {
  color: #e6e6e6;
}

::-webkit-input-placeholder:focus { /* Edge */
  color: #ffffff;
}

:-ms-input-placeholder { /* Internet Explorer */
  color: #ffffff;
}

::placeholder {
  color: #ffffff;
}

input:focus{
    background: rgb(252, 255, 255);
    color: grey;
}

input{
    color: grey;
}

.btn-color-border{
    border-color: #39b54a !important;
}
</style>